(function () {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('CurveLimits', CurveLimits);

    CurveLimits.$inject = ['$resource', 'DateUtils'];

    function CurveLimits($resource, DateUtils) {
        var resourceUrl = 'api/curve-limits/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.validFrom = DateUtils.convertLocalDateFromServer(data.validFrom);
                        data.validTo = DateUtils.convertLocalDateFromServer(data.validTo);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.validFrom = DateUtils.convertLocalDateToServer(copy.validFrom);
                    copy.validTo = DateUtils.convertLocalDateToServer(copy.validTo);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.validFrom = DateUtils.convertLocalDateToServer(copy.validFrom);
                    copy.validTo = DateUtils.convertLocalDateToServer(copy.validTo);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
